module.exports = __webpack_public_path__ + "img/Jump Casting5.369b9245.jpg";